<template>
    <div>
        <ly-form-item label="币别" lw="2.5">
            <currency v-model="currency"></currency>
        </ly-form-item>
        <ly-form-item label="价格" lw="2.5">
            <InputNumber size="small" style="width:60px;" v-model="num"></InputNumber>
        </ly-form-item>


    </div>
</template>
<script>
import currency from "../baojia/currency.vue";
export default {
    props: ["bbb",],
    components: { currency },
    model: {
        prop: "bbb",
        event: "aaa",
    },
    data() {
        return {
            num: 0,
            currency: ''
        }
    },
    methods: {
        tt() {
            //console.log(this.bbb);
            eval('this.' + this.bbb);
            
        },
        price(a, b) {
            this.num = a;
            this.currency = b;
        },
        emit() {
            this.$emit('aaa', "price(" +
                this.num + ",'" +
                this.currency + "')")
        }
    },
    mounted() {
        this.tt();
    },
    watch: {
        num(v) {
            this.emit();
        },
        currency() {
            this.emit();
        },
        bbb() {
            this.tt();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/gongshi/price.vue